const defaultImageLoader = ({ src, width, quality }) => {
    const q = quality || 75;
    if (src.indexOf('?') !== -1) {
        const [url, queryString] = src.split('?');
        const params = new URLSearchParams(queryString);

        params.set('sw', params.get('scaleWidth'));
        params.delete('scaleWidth');

        params.set('sh', params.get('scaleHeight'));
        params.delete('scaleHeight');

        params.set('sm', params.get('scaleMode'));
        params.delete('scaleMode');

        return `${url}?${params.toString()}`;
    }
    return `${src}?sw=${width}&q=${q}`;
};

module.exports = defaultImageLoader;
